import constants from "../constants/constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const {
  GET_PRODUCTS, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_ERROR,
  SELECT_PRODUCT, SELECT_PRODUCT_SUCCESS, SELECT_PRODUCT_ERROR,
  GET_SELECTED_PRODUCTS, GET_SELECTED_PRODUCTS_SUCCESS, GET_SELECTED_PRODUCTS_ERROR
} = constants;

const initialState = { loading: false, products: [], selectedProducts: [], error: '' }

export const productsReducer = (state = initialState, action) => {
  const { type, products, error, message, selectedProducts } = action;
  switch (type) {
    case GET_PRODUCTS:
    case SELECT_PRODUCT:
    case GET_SELECTED_PRODUCTS:
      return { ...state, loading: true }
    case GET_PRODUCTS_SUCCESS:
    case SELECT_PRODUCT_SUCCESS:
      return { ...state, loading: false, products, message: successHandle(message) }
    case GET_SELECTED_PRODUCTS_SUCCESS:
      return { ...state, loading: false, selectedProducts: selectedProducts }
    case SELECT_PRODUCT_SUCCESS:
      return { loading: false, message: successHandle(message) }
    case GET_PRODUCTS_ERROR:
    case SELECT_PRODUCT_ERROR:
    case GET_SELECTED_PRODUCTS_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
